import { render, staticRenderFns } from "./medkitlogMonths.vue?vue&type=template&id=0074a024"
import script from "./medkitlogMonths.vue?vue&type=script&lang=js"
export * from "./medkitlogMonths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports